import React, { useEffect } from "react";
import { View, ActivityIndicator } from "react-native";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../../actions";

export default function InviteMessage({ emails, role_type }) {
    const dispatch = useDispatch();
    const { templateChild, templateParent, templateGrandparent, templateMentor, templateTeacher } = useSelector(({ invite }) => invite);

    useEffect(() => {
        dispatch(actions.getMessageTemplate(role_type, _sliceEmails()))
    }, [])

    const _sliceEmails = () => {
        let emailString = '';
        emails.map(item => emailString += ',' + item)
        emailString = emailString.slice(1)
        return emailString
    }


    let message = null;
    if (role_type === 0) message = templateChild
    else if (role_type === 1) message = templateParent
    else if (role_type === 2) message = templateGrandparent
    else if (role_type === 3) message = templateMentor
    else if (role_type === 4) message = templateTeacher
    message = message || "<div />"

    return (
        <div
            style={{ marginTop: 30, marginBottom: 30,backgroundColor: '#fff', minHeight: 200 }}
            className="invite-message mv-3"
            dangerouslySetInnerHTML={{ __html: message }}
        />
    )
}